import { Tooltip as MUITooltip } from '@mui/material';
import type { TooltipProps } from '@mui/material';
import React from 'react';

import { StyledTooltip } from './tooltip.styles';

export const Tooltip = React.forwardRef<HTMLElement, TooltipProps & { disabled?: boolean }>((props, ref) => {
  const { children, className = '', disabled = false, ...other } = props;
  if (disabled) {
    return children;
  }
  return (
    <MUITooltip {...other} arrow className={className} PopperComponent={StyledTooltip} ref={ref}>
      {children}
    </MUITooltip>
  );
});
